import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles, CheckCircle } from 'lucide-react';
import { LandingHeader } from '@/components/layout/landing-header';

const WaitlistStartPage: React.FC = () => {
  const navigate = useNavigate();

  const handleContinueWithGoogle = () => {
    // Store that we're in waitlist flow
    sessionStorage.setItem('pagemind_waitlist_flow', 'true');
    // Redirect to signup with Google
    navigate('/signup');
  };

  const benefits = [
    'Early access to PageMind AI assistant',
    'Free trial with 100 conversations/month',
    'Priority support during beta',
    'Shape the product with your feedback',
    'Special beta pricing when we launch'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <LandingHeader showBackButton={true} currentPage="waitlist" />
      
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-full text-sm font-medium shadow-lg">
            <Sparkles className="h-4 w-4" />
            <span>Private Beta Access</span>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Join the PageMind Private Beta
          </h1>
          
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Be among the first to transform your website with AI-powered conversations. 
            Limited spots available.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-12">
          <h2 className="text-2xl font-semibold mb-6">What you'll get:</h2>
          <div className="space-y-4">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start gap-3">
                <CheckCircle className="h-6 w-6 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">{benefit}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <Button 
            size="lg" 
            onClick={handleContinueWithGoogle}
            className="inline-flex items-center gap-2"
          >
            Continue with Google
            <ArrowRight className="h-5 w-5" />
          </Button>
          
          <p className="mt-6 text-sm text-gray-500">
            We use Google authentication for secure access.
            <br />
            No spam, ever. Your data is safe with us.
          </p>
        </div>
      </section>
    </div>
  );
};

export default WaitlistStartPage;